var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"浙江宁波（省）","name":"first"}},[_c('ningbo-province-list')],1),_c('el-tab-pane',{attrs:{"label":"浙江宁波（市）","name":"second"}},[_c('ningbo-city-list')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }